var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('List',{staticClass:"pt-5",attrs:{"title":"Atelier","url":"/atelier","category":"atelier","items":_vm.atelier}})}
var staticRenderFns = []

export { render, staticRenderFns }